// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1090":"78b3bc9141b9d460a268","3492":"2513f4da4a14fc6250a5","7662":"06b3fc6c4b38bd3e2e2f"}[chunkId] + ".js";
};